import Required from '../../../../common/components/fields/Required';
import {useI18n} from '../../../../common/providers/I18nProvider';

interface Props {
	text: string;
	required?: boolean;
}

export default function Label({text, required}: Props) {
	const {i18n} = useI18n();

	return (
		<label className='text-sm lg:text-base font-medium text-black-10 mb-2'>
			{i18n(text)}
			{required && <Required />}
		</label>
	);
}
